import React from 'react';
const stats = [{
  value: '+300',
  label: 'profesionales confían'
}, {
  value: '6+6',
  label: 'Tomos + Bonos'
}, {
  value: '4.9/5',
  label: 'calificación ⭐'
}, {
  value: '🇦🇷',
  label: 'Todo el país'
}];
const testimonials = [{
  initials: 'LP',
  quote: '"Organicé todo el año en una tarde. Tengo cada sesión pensada, secuenciada y fundamentada para cada rango de edad."',
  author: '— Laura P., Buenos Aires | Estimuladora Temprana en Gabinete Privado'
}, {
  initials: 'MC',
  quote: '"Los checklists me salvaron. Ahora puedo detectar señales de alerta y hablar con las familias con seguridad y criterio profesional real."',
  author: '— Mariela C., Rosario | Estimuladora Temprana — Centro de Desarrollo Infantil'
}, {
  initials: 'SV',
  quote: '"Antes llegaba al lunes sin plan. Ahora tengo 24 semanas resueltas por etapa. Duermo los domingos por primera vez."',
  author: '— Sofía V., Córdoba | Estimuladora Temprana Independiente'
}];
export function SocialProof() {
  return <section className="w-full px-4 py-8 text-gray-900 text-base leading-6" style={{
    backgroundColor: 'rgb(240, 249, 255)',
    fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif'
  }} data-id="element-481">
      <div className="mx-auto max-w-4xl" data-id="element-482">

        {/* Stats Grid */}
        <div className="mb-8 grid grid-cols-2 md:grid-cols-4 gap-3 text-center" data-id="element-483">
          {stats.map(stat => <div key={stat.label} data-id="element-484">
              <div className="text-2xl sm:text-4xl leading-[32px] sm:leading-[40px] font-black text-gray-900" data-id="element-485">
                {stat.value}
              </div>
              <div className="mt-1 text-[10px] sm:text-xs font-semibold text-cyan-brand" data-id="element-486">
                {stat.label}
              </div>
            </div>)}
        </div>

        {/* Testimonials Grid */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-3" data-id="element-487">
          {testimonials.map(t => <div key={t.initials} className="flex items-start gap-2 bg-white border border-cyan-brand/20 rounded-lg p-3 shadow-sm" data-id="element-488">
              <div className="flex h-8 w-8 shrink-0 items-center justify-center bg-cyan-brand/10 text-xs font-black text-cyan-brand rounded-full" data-id="element-489">
                {t.initials}
              </div>
              <div data-id="element-490">
                <div className="mb-1 text-[10px] text-cyan-brand" data-id="element-491">
                  ⭐⭐⭐⭐⭐
                </div>
                <p className="text-xs font-medium text-gray-900 m-0" data-id="element-492">
                  {t.quote}
                </p>
                <p className="text-[10px] text-gray-500 mt-1 mb-0" data-id="element-493">
                  {t.author}
                </p>
              </div>
            </div>)}
        </div>

      </div>
    </section>;
}